// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD0JF_0owT8K77o-G6e1EX4AChPdnVVMa8",
  authDomain: "momin-portfolio.firebaseapp.com",
  databaseURL: "https://momin-portfolio.firebaseio.com",
  projectId: "momin-portfolio",
  storageBucket: "momin-portfolio.appspot.com",
  messagingSenderId: "840914873888",
  appId: "1:840914873888:web:a062ceaf731e9ad4669645",
  measurementId: "G-8YNZYWP018",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { app, analytics, db };
